import pimg1 from '../images/project/1.jpg';
import pimg2 from '../images/project/2.jpg';
import pimg3 from '../images/project/3.jpg';
import pimg4 from '../images/project/4.jpg';
import pimg5 from '../images/project/5.jpg';
import pimg6 from '../images/project/6.jpg';
import pimg7 from '../images/project/7.jpg';
import pimg8 from '../images/project/8.jpg';
import pimg9 from '../images/project/9.jpg';


import p2img1 from '../images/project-details/img-1.jpg'
import p2img2 from '../images/project-details/img-2.jpg'
import p2img3 from '../images/project-details/img-3.jpg'
import p2img4 from '../images/project-details/img-4.jpg'
import p2img5 from '../images/project-details/img-5.jpg'
import p2img6 from '../images/project-details/img-6.jpg'
import p2img7 from '../images/project-details/img-7.jpg'
import p2img8 from '../images/project-details/img-8.jpg'
import p2img9 from '../images/project-details/img-9.jpg'

import p3img1 from '../images/project-details/1.jpg'
import p3img2 from '../images/project-details/2.jpg'
import p3img3 from '../images/project-details/3.jpg'
import p3img4 from '../images/project-details/4.jpg'
import p3img5 from '../images/project-details/5.jpg'
import p3img6 from '../images/project-details/6.jpg'
import p3img7 from '../images/project-details/7.jpg'
import p3img8 from '../images/project-details/8.jpg'
import p3img9 from '../images/project-details/9.jpg'








const Projects = [
    {
        id: '1',
        title: 'Shelter for the Homeless',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Custom-Fabrication',
        pimg1: pimg1,
        pSimg: p2img1,
        p3Simg: p3img1,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '2',
        title: 'Empowering Through Food',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Manufacturing-Plan',
        pimg1: pimg2,
        pSimg: p2img2,
        p3Simg: p3img2,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '3',
        title: 'Collected for the Winter',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Mechanical-Works',
        pimg1: pimg3,
        pSimg: p2img3,
        p3Simg: p3img3,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },

    {
        id: '4',
        title: 'Clean Water to Rural',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Chemical-Refinery',
        pimg1: pimg4,
        pSimg: p2img4,
        p3Simg: p3img4,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '5',
        title: 'Plastic in Cities to Recycle',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Petroleum-Production',
        pimg1: pimg5,
        pSimg: p2img5,
        p3Simg: p3img5,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '6',
        title: ' Take Action to Defend Black ',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Petroleum-Production',
        pimg1: pimg6,
        pSimg: p2img6,
        p3Simg: p3img6,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '7',
        title: ' Water Purification Systems',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Petroleum-Production',
        pimg1: pimg7,
        pSimg: p2img7,
        p3Simg: p3img7,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '8',
        title: 'children  suffer for  cloths',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Petroleum-Production',
        pimg1: pimg8,
        pSimg: p2img8,
        p3Simg: p3img8,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '9',
        title: 'Provide clean over syria.',
        subtitle: 'Child & old care',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Petroleum-Production',
        pimg1: pimg9,
        pSimg: p2img9,
        p3Simg: p3img9,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    }




]
export default Projects;






